import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

interface InfoCardProps {
  icon:SvgIconComponent;
  description: string;
  value: string;
  iconBgColor?: string;
  iconColor?: string;
  valueColor?: string;
}

export const InfoCard = ({
  icon: Icon,
  description,
  value,
  iconBgColor = "#EFF6FF",
  iconColor = "#3B82F6",
  valueColor = "#3B82F6",
  }: InfoCardProps) => {
  return (
    <Card
      elevation={0}
      sx={{
        width: 700,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "grey.100",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" gap={2}>
          <Box flex={1}>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontWeight: 500, lineHeight: 1.3,fontSize: 15 }}
            >
              {description}
            </Typography>
            
          </Box>
        
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: valueColor,
                textAlign: "right",
                fontFamily: "monospace",
              }}
            >
              {value === "Amount" ? value : `£${value.toLocaleString()}`}
            </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

